import React from 'react';
import GcspForecast from '@pages/forecast/gcspForecast';

const Profile = () => {
  return (
    <div>
      <GcspForecast />
    </div>
  );
};

export default Profile;
